function favoritesNotificationApp() {
  return {
    show: false,
    product_title: "",
    label: "",
    init() {
      document.addEventListener("addedToFavorites", (evt) => {
        this.product_title = evt.detail.product_title;
        this.label = "Added to Favorites";
        this.show = true;
      });
      document.addEventListener("removedFromFavorites", (evt) => {
        this.product_title = evt.detail.product_title;
        this.label = "Removed from Favorites";
        this.show = true;
      });
      document.addEventListener("hideNotification", (_) => {
        this.show = false;
      });
    },
  };
}
